<template>
  <div class="das-form-container">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addServiceDialog"
      class="body-overflow__visible"
      :close-on-click-modal="false"
      width="1000px"
    >
      <div class="das-info-title">Thông tin khách</div>
      <InfoList :columns="3">
        <template>
          <InfoListLabel>Phòng</InfoListLabel>
          <InfoListValue style="width: 120px">{{
            bookingInfo.full_name
          }}</InfoListValue>

          <InfoListLabel>Tên khách</InfoListLabel>
          <InfoListValue style="width: 120px">{{
            bookingInfo.full_name
          }}</InfoListValue>

          <InfoListLabel>Ngày đến</InfoListLabel>
          <InfoListValue style="width: 120px">{{
            $displayDate(bookingInfo.arrive)
          }}</InfoListValue>

          <InfoListLabel>Ngày đi</InfoListLabel>
          <InfoListValue style="width: 120px">{{
            $displayDate(bookingInfo.depart)
          }}</InfoListValue>

          <InfoListLabel>Trang giao dịch</InfoListLabel>
          <InfoListValue style="width: 120px">{{
            `${selectedTab?.label} - ${selectedTab?.desc}` || null
          }}</InfoListValue>
        </template>
      </InfoList>
      <tab
        v-if="!isEdit"
        id="add-service"
        v-model="tabIndex"
        class="mt-10"
        :tab-list="tabList"
        @input="onTabChange"
      />
      <validation-observer ref="formValidator">
        <div class="container-11">
          <div v-if="isDetailPopup" class="transparent-overlay" />
          <div v-if="tabIndex === 1 || tabIndex === 2">
            <div class="das-form-container">
              <div class="das-form-group">
                <div class="das-form-row">
                  <div class="das-form-col col-4">
                    <div v-if="tabIndex === 1" class="das-form-input">
                      <div class="label required">Lựa chọn Check-in sớm</div>
                      <validation-provider
                        rules="required"
                        name="Lựa chọn Check-in sớm"
                      >
                        <el-select
                          v-model="submitForm.id"
                          placeholder=""
                          @change="onChangeCheckinSoon($event, 1)"
                        >
                          <el-option
                            v-for="option in earlyCheckinOptions"
                            :key="option.id"
                            :value="option.id"
                            :label="option.code"
                          />
                        </el-select>
                      </validation-provider>
                    </div>
                    <div v-else class="das-form-input">
                      <div class="label required">Lựa chọn Trả phòng muộn</div>
                      <validation-provider
                        rules="required"
                        name="Lựa chọn trả phòng muộn"
                      >
                        <el-select
                          v-model="submitForm.id"
                          placeholder=""
                          @change="onChangeCheckinSoon($event, 2)"
                        >
                          <el-option
                            v-for="option in lateCheckoutOptions"
                            :key="option.id"
                            :value="option.id"
                            :label="option.code"
                          />
                        </el-select>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="das-form-col col-4">
                    <validation-provider
                      rules="required"
                      name="Trang giao dịch"
                    >
                      <div class="das-form-input">
                        <div class="label required">Trang giao dịch</div>
                        <el-select
                          v-model="submitForm.trans_page"
                          placeholder=""
                        >
                          <el-option
                            v-for="item1 in allTranPages"
                            :key="item1.id"
                            :label="`${item1.code} - ${item1.desc}`"
                            :value="item1.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </validation-provider>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-4">
                    <validation-provider rules="required" name="Ngày giao dịch">
                      <div class="das-form-input">
                        <div class="label required">Ngày giao dịch</div>
                        <CalendarSelect
                          v-model="submitForm.trans_date"
                          mode="date"
                          :min-max="{
                            min: bookingInfo.arrive,
                            max: bookingInfo.depart
                          }"
                        />
                        <!-- <SingleCalendar v-model="submitForm.trans_date" /> -->
                      </div>
                    </validation-provider>
                  </div>
                  <div
                    v-if="submitForm.fee_type === 0"
                    class="das-form-col col-4"
                  >
                    <div class="flex align-end" style="gap: 5px">
                      <div class="das-form-input" style="flex: 2">
                        <div class="label">Phần trăm(%)</div>
                        <div class="read-only-input">
                          {{ submitForm.fee_val }}
                        </div>
                      </div>
                      x
                      <div class="das-form-input" style="flex: 3">
                        <div class="label">Số tiền(VND)</div>
                        <div class="read-only-input">
                          {{ this.$displayCurrency(moneyPerday) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Total money get from computed -->
                  <div class="das-form-col col-4">
                    <div class="das-form-input">
                      <div class="label">Thành tiền(VND)</div>
                      <div class="flex gap-10">
                        <div class="read-only-input" style="flex: 2">
                          {{ $displayCurrency(totalMoney) }}
                        </div>
                        <el-select
                          v-model="submitForm.currency_id"
                          placeholder=""
                          style="flex: 1"
                        >
                          <el-option label="VND" :value="5" />
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">Ghi chú</div>
                      <textarea
                        v-model="submitForm.note"
                        style="width: 100%"
                        type="text"
                        :rows="3"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tabIndex === 3">
            <div class="das-info-title">Thông tin giá</div>
            <InfoList
              :columns="3"
              :column-breakpoint-options="{
                md: 3,
                lg: 3,
                xl: 3
              }"
            >
              <template>
                <InfoListLabel>Mã:</InfoListLabel>
                <InfoListValue>{{ submitForm.code }}</InfoListValue>

                <InfoListLabel>Giá người lớn:</InfoListLabel>
                <InfoListValue
                  >{{
                    $displayCurrency(submitForm?.adult_price) || null
                  }}
                  VND</InfoListValue
                >

                <InfoListLabel>Giá trẻ em:</InfoListLabel>
                <InfoListValue
                  >{{
                    $displayCurrency(submitForm?.child_price) || null
                  }}
                  VND</InfoListValue
                >
                <!-- <InfoListLabel>Tên khách sạn:</InfoListLabel>
                <InfoListValue>{{
                  submitForm?.hotel_name || null
                }}</InfoListValue>
                <InfoListLabel>Mô tả:</InfoListLabel>
                <InfoListValue
                  >{{ submitForm?.description || null }}
                </InfoListValue> -->
              </template>
            </InfoList>
            <div class="das-form-container">
              <div class="das-form-group border-bottom mt-10">
                <div class="das-form-group-title">Thông tin giao dịch</div>
                <div class="das-form-row">
                  <div class="das-form-col col-4">
                    <validation-provider
                      rules="required"
                      name="Trang giao dịch"
                    >
                      <div class="das-form-input">
                        <div class="label required">Trang giao dịch</div>
                        <el-select
                          v-model="submitForm.trans_page"
                          placeholder=""
                        >
                          <el-option
                            v-for="item1 in allTranPages"
                            :key="item1.id"
                            :label="`${item1.code} - ${item1.desc}`"
                            :value="item1.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </validation-provider>
                  </div>
                  <div class="das-form-col col-4">
                    <validation-provider rules="required" name="Ngày giao dịch">
                      <div class="das-form-input">
                        <div class="label required">Ngày giao dịch</div>
                        <CalendarSelect
                          v-model="submitForm.trans_date"
                          mode="date"
                          :min-max="{
                            min: minDate,
                            max: bookingInfo.depart
                          }"
                        />
                        <!-- <SingleCalendar v-model="submitForm.trans_date" /> -->
                      </div>
                    </validation-provider>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">Ghi chú</div>
                      <textarea v-model="submitForm.note" :rows="3" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="height: 200px">
              <GridVx
                ref="breakfastAgGrid"
                :columns="breakfastCols"
                :auto-size-cell="true"
                :auto-select-first-row="false"
                dom-layout="scroll"
                :rows="breakfastRows"
                class="agGrid"
                :context="context"
              />
            </div>

            <div class="total-money-container">
              <span class="das-info-list-label">Thành tiền:</span>
              <span class="currency"
                >{{ $displayCurrency(breakfastMoney) || 0 }} VNĐ</span
              >
            </div>
          </div>
        </div>
      </validation-observer>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="addServiceDialog = false"
          >
            Đóng
          </button>
          <button
            v-if="isEdit && !isDetailPopup"
            :disabled="breakfastMoney < 0"
            class="btn primary small"
            @click="updateTransaction"
          >
            Cập nhật
          </button>
          <button
            v-if="!isEdit && !isDetailPopup"
            :disabled="breakfastMoney < 0"
            class="btn primary small"
            @click="addTransaction"
          >
            Tạo mới
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Tab from '@/components/Tab'
import {
  getEarlyCheckinOptionsApi,
  submitEarlyCheckinFormApi,
  getBreakfastInfoApi,
  updateEarlyCheckinFormApi
} from '@/api/cashier_service/postTransaction'
import {
  CellRenderTextInput,
  CellRenderDeleteIcon,
  CellHeaderAddIcon,
  CellRenderCalendar
} from '@/utils/cellRenders.js'
import { CellRenderCalendarSelectForTable } from '@/utils/groupCellRenders.js'
import { updateCardPeriod } from '@/api/reception/card_service'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Tab,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderTextInput,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderDeleteIcon,
    // eslint-disable-next-line vue/no-unused-components
    CellHeaderAddIcon,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCalendar,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCalendarSelectForTable
  },
  props: {
    isDetailPopup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      earlyPrice: 0,
      latePrice: 0,
      moneyPerday: 0,
      isEdit: false,
      context: null,
      breakfastStartDate: null,
      breakfastEndDate: null,
      earlyCheckinOptions: [],
      lateCheckoutOptions: [],
      submitForm: {
        type: null,
        code: null,
        transaction_id: null,
        sub_transaction_id: null,
        time_frame_from: null,
        time_frame_to: null,
        fee_type: null,
        fee_val: null,
        currency_id: 5,
        inputMoney: 0
      },
      form1: {
        select: null,
        percent: 70,
        money: 20000
      },
      datePeriod: {
        start_date: null,
        to_date: null
      },
      addServiceDialog: false,
      tabIndex: 1,
      tabList: [
        {
          label: 'Check-in sớm',
          value: 1
        },
        {
          label: 'Trả phòng muộn',
          value: 2
        },
        {
          label: 'Ăn sáng',
          value: 3
        }
      ],
      breakfastCols: [
        {
          headerName: 'Ngày',
          field: 'date',
          cellRenderer: 'CellRenderCalendarSelectForTable',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'date',
              clearable: true,
              dateType: 'date',
              format: 'dd/MM/yyyy',
              valueFormat: 'yyyy-MM-dd'
            }
          },
          maxWidth: 150
        },
        {
          headerName: 'Số người lớn',
          field: 'adult',
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: () => {
            return {
              type: 'number'
            }
          }
        },
        {
          headerName: 'Số trẻ em',
          field: 'child',
          cellRenderer: 'CellRenderTextInput'
        },
        {
          headerName: 'Số trẻ em (< 5 tuổi)',
          field: 'infant',
          cellRenderer: 'CellRenderTextInput'
        },
        {
          headerName: '',
          width: 50,
          cellRenderer: 'CellRenderDeleteIcon',
          headerComponent: 'CellHeaderAddIcon',
          cellStyle: () => {
            return {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          },
          cellRendererParams: () => {
            return {
              agGrid: 'modifyQuantityDialog'
            }
          }
        }
      ],
      breakfastRows: [],
      dialogTitle: null
    }
  },
  computed: {
    bookingInfo() {
      return this.$store.getters['cashier']
    },
    allTranPages() {
      return this.$store.getters['allTranPages']
    },
    transactions() {
      return this.$store.getters['transactions']
    },
    selectedTab() {
      return this.$store.getters['selectedTab']
    },
    totalMoney() {
      const money = Number(this.moneyPerday)
      if (this.submitForm.fee_type === 0) {
        const percent = 0.01 * Number(this.submitForm.fee_val)
        if (isNaN(money) || isNaN(percent)) {
          return 0
        } else {
          return money * percent
        }
      } else {
        return this.submitForm.fee_val
      }
    },
    breakfastMoney() {
      const adultPrice = this.submitForm.adult_price
      const childPrice = this.submitForm.child_price
      let amount = 0
      if (this.breakfastRows.length > 0) {
        this.breakfastRows.forEach(item => {
          const adult = Number(item['adult']) * adultPrice
          const child = Number(item['child']) * childPrice
          amount += adult + child
        })
      }
      return amount
    },
    minDate() {
      const today = this.$moment(new Date()).format('YYYY-MM-DD')
      if (today > this.bookingInfo.arrive) {
        return today
      } else {
        return this.bookingInfo.arrive
      }
    }
  },
  watch: {
    addServiceDialog() {
      this.addServiceDialog
        ? this.setDialogTitle()
        : this.resetAddServiceDialog()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  methods: {
    setTranPage() {
      if (!this.isEdit && !this.isDetailPopup) {
        this.submitForm.trans_page = this.allTranPages[0]?.id || null
      }
    },
    setTransDate() {
      // eslint-disable-next-line no-unused-vars
      const currentDate = this.$moment(new Date()).format('YYYY-MM-DD')
      const arriveDate = this.bookingInfo.arrive
      const departDate = this.bookingInfo.depart
      if (arriveDate && departDate) {
        if (
          currentDate >= this.$moment(arriveDate).format('YYYY-MM-DD') &&
          currentDate <= this.$moment(departDate).format('YYYY-MM-DD')
        ) {
          this.submitForm.trans_date = this.$moment(new Date()).format(
            'YYYY-MM-DD'
          )
        }
      }
    },
    setDialogTitle() {
      // set dialog title
      this.dialogTitle = 'Thêm giao dịch'
      if (this.isEdit) {
        this.dialogTitle = 'Sửa giao dịch'
      }
      if (this.isDetailPopup) {
        this.dialogTitle = 'Chi tiết giao dịch'
      }
      this.setTranPage()
      this.isEdit ? null : this.setTransDate()
    },
    onAddRowInGrid() {
      this.breakfastRows.push({
        date: this.$moment(new Date()).format('YYYY-MM-DD'),
        adult: 0,
        child: 0,
        infant: 0
      })
    },
    onDeleteIconClicked(data) {
      const idx = data.rowIndex
      this.breakfastRows.splice(idx, 1)
    },
    changeCalendar(params, value, colName) {
      const idx = params.rowIndex
      this.breakfastRows[idx][colName] = value
    },
    textInputChange(params, value, colId) {
      if (Number(value) < 0) {
        this.$refs.breakfastAgGrid.gridApi.forEachNode(node => {
          this.$message({
            message: 'Số lượng người nhập vào không hợp lệ',
            type: 'error'
          })
          node.setDataValue(colId, 1)
          this.breakfastRows[idx][colId] = 1
        })
      }
      const idx = params.rowIndex
      this.breakfastRows[idx][colId] = value
    },
    checkExpiredDate() {
      let output = true
      const dates = this.breakfastRows.map(item => item.date)
      const today = new Date().setHours(0, 0, 0, 0)
      const depart = new Date(this.bookingInfo.depart).setHours(0, 0, 0, 0)
      dates.forEach(item => {
        const date = new Date(item).setHours(0, 0, 0, 0)
        if (date < today || date > depart) {
          output = false
        }
      })
      return output
    },
    async addTransaction() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      if (!this.checkExpiredDate()) {
        this.$message({
          message: 'Ngày không hợp lệ',
          type: 'error'
        })
        return
      }
      if (this.tabIndex === 3) {
        // breakfast
        this.submitForm.money = this.breakfastMoney
      } else {
        // others
        this.submitForm.money = this.totalMoney
      }
      this.submitForm.breakfasts = this.breakfastRows
      this.submitForm.sub_booking_group_id = this.bookingInfo.id
      this.submitForm.early_late_check_id = this.submitForm.id
      try {
        const res = await submitEarlyCheckinFormApi(this.submitForm)

        if (res) {
          if (this.tabIndex === 2) {
            updateCardPeriod({
              roomId: this.bookingInfo.room_id,
              startDate: this.bookingInfo.check_in_date,
              endDate: `${this.bookingInfo.depart} ${this.submitForm.time_frame_to}:00`
            })
          }
          const message = res.message
          this.addServiceDialog = false
          this.$store.dispatch('cashier/changeTransactionListIndex')
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        }
      } catch (error) {
        const message = error.response?.data?.message || 'default'
        this.$message({
          type: 'error',
          message: this.$t(`errorMsg.${message}`)
        })
      }
    },
    async updateTransaction() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      if (this.tabIndex === 3) {
        // breakfast
        this.submitForm.money = this.breakfastMoney
      } else {
        // others
        this.submitForm.money = this.totalMoney
      }
      this.submitForm.breakfasts = this.breakfastRows
      this.submitForm.sub_booking_group_id = this.bookingInfo.id
      this.submitForm.early_late_check_id = this.submitForm.id

      const params = {
        roomTransactionId: this.transactions[0].id
      }
      await updateEarlyCheckinFormApi(params, this.submitForm)
        .then(async res => {
          const message = res.message
          this.addServiceDialog = false
          this.$store.dispatch('cashier/changeTransactionListIndex')
          this.$emit('done')
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    onChangeCheckinSoon(id, type) {
      // this.$nullValueInObj(this.submitForm)
      // Reset data
      // this.submitForm.fee_type = 1
      if (!id) {
        return
      }
      let data = []
      if (type === 1) {
        // checkin early
        data = this.earlyCheckinOptions.filter(item => item.id === id) || []
      } else {
        // checkout late
        data = this.lateCheckoutOptions.filter(item => item.id === id) || []
      }
      if (data.length > 0) {
        Object.assign(this.submitForm, data[0])
      }
    },
    async getEarlyCheckinOptions() {
      const params = {
        early: true,
        subBookingGroupId: this.bookingInfo.id
      }
      const params1 = {
        early: false,
        subBookingGroupId: this.bookingInfo.id
      }
      const data = await getEarlyCheckinOptionsApi(params)
      this.earlyCheckinOptions = data?.data?.early || []
      this.earlyPrice = data?.data?.money
      //
      const data1 = await getEarlyCheckinOptionsApi(params1)
      this.lateCheckoutOptions = data1?.data?.late || []
      this.latePrice = data1?.data?.money
    },
    async openAddServiceDialog() {
      await this.getEarlyCheckinOptions()
      this.moneyPerday = this.earlyPrice
      this.addServiceDialog = true
    },
    async openUpdateServiceDialog() {
      this.isEdit = true
      const row = this.transactions[0]
      Object.assign(this.submitForm, row)
      if (row?.breakfast_data.length > 0) {
        this.tabIndex = 3
        // breakfast type
        this.submitForm.code = row.breakfast.breakfast_code_code
        this.submitForm.adult_price = row.breakfast.adult_price
        this.submitForm.child_price = row.breakfast.child_price
        this.submitForm.breakfast_code_id = row.breakfast.breakfast_code_id
        this.datePeriod.start_date = row.breakfast_data[0]['date']
        this.datePeriod.start_date =
          row.breakfast_data[row.breakfast_data.length - 1]['date']
        this.breakfastRows = row.breakfast_data
      } else {
        await this.getEarlyCheckinOptions()
        if (row?.early_late_check?.type === 0) {
          // early checkin
          this.tabIndex = 1
          this.moneyPerday = this.earlyPrice
        } else {
          // late checkout
          this.tabIndex = 2
          this.moneyPerday = this.latePrice
        }
        this.submitForm.id = row.early_late_check.id
        this.submitForm.fee_type = row.early_late_check.fee_type
        if (this.submitForm.fee_type === 0) {
          // percent type
          this.submitForm.fee_val = row.early_late_check.fee_value
          this.submitForm.inputMoney =
            row.money / (this.submitForm.fee_val * 0.01)
        } else {
          // amount type
          this.submitForm.money = row.money
          this.submitForm.fee_val = row.early_late_check.fee_value
        }
      }
      this.addServiceDialog = true
    },
    onTabChange(tab) {
      if (tab === 1) {
        this.moneyPerday = this.earlyPrice
      } else if (tab === 2) {
        this.moneyPerday = this.latePrice
      } else if (tab === 3) {
        this.getBreakfastInfo()
      }
      this.$nullValueInObj(this.submitForm)
      this.setTranPage()
      this.setTransDate()
      this.submitForm.currency_id = 5
      this.breakfastRows = []
    },
    async getBreakfastInfo() {
      const params = {
        hotelId: this.bookingInfo.hotel_id
      }
      const data = await getBreakfastInfoApi(params)
      Object.assign(this.submitForm, data.data)
      this.submitForm.sub_transaction_id = this.submitForm.sub_trading_code_id
      this.submitForm.breakfast_code_id = this.submitForm.id
    },
    resetAddServiceDialog() {
      this.tabIndex = 1
      this.isEdit = false
      this.breakfastRows = []
      this.$nullValueInObj(this.submitForm)
      this.submitForm.currency = 5
      this.$emit('resetDialog')
    }
  }
}
</script>

<style lang="scss" scoped>
.container-11 {
  position: relative;
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid #d8dee5;
  border-radius: 5px;
  border-top-left-radius: 0;
}
.total-money-container {
  text-align: end;
  font-size: 18px;
  margin: 10px 0;
  .currency {
    color: #357456;
    font-weight: 700;
  }
}
</style>
